import Phaser from "phaser";
import { BootScene } from "./game/scenes/BootScene";
import { RunScene } from "./game/scenes/RunScene";
import { HudScene } from "./game/scenes/HudScene";
import { OverlayUi } from "./game/ui/OverlayUi";
import { GAME_HEIGHT, GAME_WIDTH } from "./game/constants";
import { installGlobalErrorOverlay, loadErudaIfRequested } from "./game/debug/CrashReporter";

// Debug instrumentation (PASO 1): surface uncaught errors on-screen (readable on
// the Motorola phone) and optionally load the Eruda console with ?eruda=1.
installGlobalErrorOverlay();
loadErudaIfRequested();

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.WEBGL,
  parent: "game-root",
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: "#050708",
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH
  },
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false
  },
  scene: [BootScene, RunScene, HudScene]
};

const game = new Phaser.Game(config);
new OverlayUi(game);

window.addEventListener("keydown", (event) => {
  if (event.key === "F10") {
    game.events.emit("debug:toggle");
  }
});

(window as unknown as { runCampeonGame: Phaser.Game }).runCampeonGame = game;
